import React from "react";
import styles from "./Navbar.module.scss";

interface Props {
  children?: string | JSX.Element | JSX.Element[];
  title: string;
  className?: string;
}

const Navbar = ({ children, title, className = "" }: Props) => (
  <nav className={`${styles.navbar} ${className}`.trim()}>
    <header className={styles.navbarHeader}>
      <h1>{title}</h1>
    </header>

    {!!children && <div className={styles.navbarContent}>{children}</div>}
  </nav>
);

export default Navbar;
